export interface ComponentConfig {
  title: string;
  theme: 'default' | 'colorful' | 'minimal';
}

export interface ComponentProps {
  config: ComponentConfig;
  readonly?: boolean;
}

/** 语言代码：0=中文，2=英文（与 ELang.KV 一致） */
export type LanguageCode = 0 | 2;

export interface LocalizedText {
  0?: string;
  2?: string;
}

/**
 * 多语言标签项（新格式）
 * 包含排序权重和多语言标签名
 */
export interface LocalizedTag {
  /** 排序权重，数字越小越靠前 */
  sortOrder: number;
  /** 多语言标签名 */
  label: LocalizedText;
}

export function getLocalizedValue(
  value: string | LocalizedText | undefined,
  lang: LanguageCode,
): string | undefined {
  if (!value) return undefined;
  if (typeof value === 'string') return value;
  return value[lang];
}

/**
 * 处理标签数组，返回排序后的标签列表
 * 按 sortOrder 排序后提取对应语言的标签文本
 */
export function getTagsFromConfig(
  tags: LocalizedTag[] | undefined,
  lang: LanguageCode,
): string[] {
  if (!tags || tags.length === 0) return [];

  return tags
    .slice()
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((tag) => tag.label?.[lang])
    .filter((text): text is string => !!text);
}
